import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  container: {
    padding: '75px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 35px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
  },
  boxes: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    alignItems: 'center',
    //direction: 'rtl',
    '@media (max-width: 700px)': {
      gridTemplateColumns: '1fr',
    },
  },
  boxesText: {
    paddingRight: 30,
    '@media (max-width: 700px)': {
      paddingRight: 0,
    },
  },
  boxesImg: {},
  title: {
    fontSize: '38px',
    lineHeight: '41px',
    textAlign: 'left',
    marginBottom: '17px',
    fontFamily: 'TTRounds',
    '@media (max-width: 700px)': {
      marginBottom: '10px',
    },
    '& a': {
      color: '#000',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  summary: {
    fontSize: '18px',
    lineHeight: '26px',
    textAlign: 'left',
    marginBottom: '40px',
    '@media (max-width: 700px)': {
      marginBottom: '20px',
    },
    '& a': {
      color: '#000',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  btn: {
    textAlign: 'left',
    '& a': {
      color: '#fff',
      backgroundColor: theme.colors.orange,
      padding: '17px 30px',
      fontFamily: 'TTRounds',
      borderRadius: 14,
      display: 'inline-block',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
      },
    },
  },
  boxesImg: {
    textAlign: 'center',
    '@media (max-width: 700px)': {
      paddingTop: '15px',
    },
    '& img': {
      objectFit: 'cover',
      borderRadius: 30,
      maxWidth: '100%',
      height: '400px',
    },
  },
}))

const BlogHeader = ({ title, url, BlogPage }) => {
  const classes = useStyles()

  return (
    <div>
      <div className={classes.container}>
        <div className={classes.boxes}>
          <div className={classes.boxesText}>
            <div className={classes.title}>
              <a href={url}>{title}</a>
            </div>
            {BlogPage.summary && (
              <div className={classes.summary}>
                <a href={url}>{BlogPage.summary}</a>
              </div>
            )}
            <div className={classes.btn}>
              <a href={url}>Read Article</a>
            </div>
          </div>
          <div className={classes.boxesImg}>
            <a href={url}>
              <img src={BlogPage.img} alt={title} />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

BlogHeader.defaultProps = {}

export default BlogHeader
